import { useMutation } from "@tanstack/react-query";
import AIService from "src/services/api/aiLabeling";


export const useMutateSinglePrediction = () => {
  const { isPending, mutateAsync } = useMutation({
    mutationFn: (body: Record<string, string>) => AIService.getSinglePrediction(body),
  });
  return {
    isPending,
    mutateAsync,
  };
}
export const useMutateUploadFile = () => {
  const { isPending, mutateAsync } = useMutation({
    mutationFn: (file: File) => AIService.uploadFile(file),
  });
  return {
    isPending,
    mutateAsync,
  };
}
export const useMutateMappingField = () => {
  const { isPending, mutateAsync } = useMutation({
    mutationFn: (dto: Record<string, any>) => AIService.mappingField(dto),
  });
  return {
    isPending,
    mutateAsync,
  };
}
export const useMutateExportBulkUploadResult = () => {
  const { isPending, mutateAsync } = useMutation({
    mutationFn: (dto: Record<string, any>) => AIService.exportBulkUploadResult(dto),
  });
  return {
    isPending,
    mutateAsync,
  };
}